import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { onResize } from "@js/throttle.js"

gsap.registerPlugin(ScrollTrigger);

function checkStickySections() {
    // Cache viewport calculations outside the loop
    const navHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--nav-height');
    const navHeight = parseInt(navHeightVar) || 0;
    const viewportHeight = window.innerHeight - navHeight;

    document.querySelectorAll('.sticky-section').forEach(section => {
		const sectionHeightVar = getComputedStyle(section).getPropertyValue('--section-height');
		const sectionHeight = parseInt(sectionHeightVar) || section.offsetHeight;

        const shouldPause = sectionHeight > viewportHeight;

        // Only modify class if it needs to change (prevents observer loops)
        if (shouldPause && !section.classList.contains('sticky-section-paused')) {
            section.classList.add('sticky-section-paused');
        } else if (!shouldPause && section.classList.contains('sticky-section-paused')) {
            section.classList.remove('sticky-section-paused');
        }
    });
}

export default function handleFixedSections() {
    // Initial update
    checkStickySections();

    // Update on window resize
    onResize(() => {
        checkStickySections();
    });
}

// Cache earth text elements to avoid repeated querySelector calls
let earthTextElements = null;

export function calculateEarthTextOpacity() {
	function calculateOpacity() {
		// Convert rem to pixels (assuming 1rem = 16px)
		const minWidth = 24 * 16; // 24rem in pixels
		const maxWidth = 90 * 16; // 90rem in pixels

		// Get current viewport width
		const currentWidth = window.innerWidth;

		// If smaller than minimum width, return maximum opacity
		if (currentWidth <= minWidth) {
			return 0.3;
		}

		// If larger than maximum width, return minimum opacity
		if (currentWidth >= maxWidth) {
			return 0.06;
		}

		// Calculate the percentage between min and max width
		const percentage = (currentWidth - minWidth) / (maxWidth - minWidth);

		// Interpolate between max opacity (0.3) and min opacity (0.06)
		return 0.3 - (percentage * (0.3 - 0.06));
	}

	// Cache element selection on first run
	if (!earthTextElements) {
		earthTextElements = document.querySelectorAll('.earth-text');
	}

    const opacity = calculateOpacity();
    earthTextElements.forEach(el => el.style.opacity = opacity);
}
